import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import _ from 'lodash';
import DateTime from 'ziphy-web-shared/basic/lib/forms/builder/ui/fields/dateTime/DateTime';
import { isValidDateString } from 'ziphy-web-shared/basic/utils/time';
const ToggleButtonPlain = ({ field, items, withText }) => {
    var _a;
    return items && !_.isEmpty(field.value) ? (_jsx("span", { children: typeof field.value === 'string'
            ? ((_a = items.find((item) => item.id === field.value)) === null || _a === void 0 ? void 0 : _a.text) || field.value
            : Object.entries(field.value).map(([key, value], index) => {
                let item = items.find((item) => item.id === key);
                if (value === true || isValidDateString(value) || field.name === 'language') {
                    if (typeof (item === null || item === void 0 ? void 0 : item.extraField) === 'object' && 'items' in item.extraField) {
                        const subItems = item.extraField.items;
                        item = subItems.find((item) => item.id === value) || item;
                    }
                    return (_jsxs(Fragment, { children: [index > 0 ? ', ' : null, (item === null || item === void 0 ? void 0 : item.text) || key, _jsx(DateTime, { datetime: value })] }, index));
                }
                const text = withText ? item === null || item === void 0 ? void 0 : item.text : null;
                return (_jsxs(Fragment, { children: [index > 0 ? ', ' : null, text ? `${text} • ${value}` : value, _jsx(DateTime, { datetime: value })] }, index));
            }) })) : null;
};
export default ToggleButtonPlain;
